import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const bitsight = defineConnector({
  identifier: "bitsight",
  name: "Bitsight",
  tagLine: "Security ratings and third-party risk",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.bitsighttech.com/ratings"),
  auth: basicAuth({
    username: { from: "secret", field: "apiToken" },
    password: { from: "literal", value: "" },
  }),
  steps: [
    {
      title: "Set up Bitsight",
      items: [
        {
          kind: "markdown",
          content:
            "In Bitsight, open **Settings → Account → User Preferences** and copy your API token. Prefer a user token with the read access needed for your workflows; company tokens carry administrator privileges. See [API token management](https://help.bitsighttech.com/hc/en-us/articles/115014888388-API-Token-Management).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.bitsighttech.com/ratings",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use https://api.bitsighttech.com/ratings without a version suffix. The connection test appends /v2/portfolio and requests at most one company.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText: "A user API token or company API token.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.bitsighttech.com/ratings")
          .trim()
          .replace(/\/+$/, "") + "/v2/portfolio?limit=1",
      ...{ method: "GET" },
    }),
  },
});
